// The API serialises camera roles as a stringified Python list, e.g.
// "['person_tracking_top_view', 'shelf_monitoring']". Pull the role names
// back out so they can be displayed, matched and offered as filter options.
export const parseRoles = (roles) =>
  (roles ?? "").split(/[^a-z0-9_]+/i).filter(Boolean);

export const roleLabel = (role) =>
  role.split("_").map((w) => w.charAt(0).toUpperCase() + w.slice(1)).join(" ");
